export const TIER_CONFIG = {
  member: { emoji: "🐟", label: "MINNOW", color: "#4fd1c5", threshold: "$10K", thresholdValue: 10000 },
  trusted: { emoji: "🐠", label: "SNAPPER", color: "#af58f2", threshold: "$50K", thresholdValue: 50000 },
  whale: { emoji: "🦈", label: "SHARK", color: "#8c00ff", threshold: "$100K", thresholdValue: 100000 },
  beluga: { emoji: "🐬", label: "DOLPHIN", color: "#ea00ff", threshold: "$500K", thresholdValue: 500000 },
  bluewhale: { emoji: "🐋", label: "WHALE", color: "#1976d2", threshold: "$1M", thresholdValue: 1000000 },
};

export const TIER_ORDER = ["member", "trusted", "whale", "beluga", "bluewhale"];

export const TIER_BENEFITS = {
  member: "Complete orders to start unlocking higher tiers.",
  trusted: "Snapper unlocks special deals, higher commit limits & faster participation.",
  whale: "Shark unlocks priority support and premium commit access.",
  beluga: "Dolphin unlocks top-tier payout speed and exclusive drops.",
  bluewhale: "You've reached the highest tier — thank you for being a top RSC seller.",
};

export function getTierKey(user) {
  // discord_role is the backend's real, highest-rank-first array of Discord
  // role names (e.g. ["Blue Whale"]) — but "Blue Whale".toLowerCase() is
  // "blue whale" (with a space), which never matched the space-free
  // TIER_CONFIG key "bluewhale". Every other tier's name has no internal
  // space, so this only ever broke the top tier — stripping whitespace
  // fixes it without changing matching for the other four.
  const roleName = user?.discord_role?.[0];
  if (!roleName) return "member";
  const normalized = roleName.toLowerCase().replace(/\s+/g, "");
  return TIER_ORDER.includes(normalized) ? normalized : "member";
}

export function stringToColor(string) {
  let hash = 0;
  for (let i = 0; i < string.length; i++) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }
  let color = "#";
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  return color;
}
